import { type FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import styled, { css } from '@mint-lib/styled';

import {
  Box,
  Icon,
  TableCellDraggable,
  TableHeaderCellExpander,
  Truncation,
} from '@myn/mui';

import { BUILDER_ROW_TYPES } from '../../../../../constants/campaignBuilder.js';

type Props = {
  expandedType?: BUILDER_ROW_TYPES;
  handleExpandRows: () => void;
  scale: number;
};

const ExpanderColumn: FC<Props> = ({
  expandedType,
  handleExpandRows,
  scale,
}) => {
  const { t } = useTranslation('@myn/planning');

  const columnName = t('Media');

  return (
    <HeaderExpandCell scale={scale}>
      <TableCellDraggable readOnly sx={{ border: 'none' }} />
      <TableHeaderCellExpander
        expanded={expandedType !== BUILDER_ROW_TYPES.TILE}
        onExpand={handleExpandRows}
        sx={{ marginRight: '16px' }}
      />
      <Logo component="MintLogoBw" scale={scale} sx={{ marginRight: '8px' }} />
      <LogoTextNew
        variant="bodyShort01"
        scale={scale}
        tooltipTitle={columnName}
      >
        {columnName}
      </LogoTextNew>
    </HeaderExpandCell>
  );
};

export default ExpanderColumn;

const HeaderExpandCell = styled(Box)<{
  scale: number;
}>`
  display: flex;
  align-items: center;
  width: inherit;
  height: 100%;
  padding: 0;
  box-shadow: none;
  border-right: 4px solid rgba(47, 57, 65, 0.08);
  overflow: hidden;

  background-color: ${({ theme }) => theme.palette.background.paper};

  & td {
    padding-top: 2px;

    ${({ scale }) => css`
      width: ${scale * 40}px;
      height: ${scale * 40}px;

      button {
        width: ${scale * 32}px;
        height: ${scale * 32}px;

        svg {
          width: ${scale * 16}px;
          height: ${scale * 16}px;
        }
      }
    `}
  }
`;

const Logo = styled(Icon)<{
  scale: number;
}>`
  ${({ scale }) => css`
    width: ${scale * 1}rem;
    height: ${scale * 1}rem;
  `}
`;

const LogoTextNew = styled(Truncation)<{
  scale: number;
}>`
  font-size: ${({ scale }) => `${scale * 1}rem`};

  /* Disable text selection */
  -webkit-user-select: none; /* Safari and other webkit-based browsers */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Generic CSS for other browsers */
`;
